import React from 'react';

import { renderModal } from 'helpers/modal-render';
import Icons from 'assets/icons';

export interface ActionMenuItem {
  label: string;
  icon: React.JSX.Element;
  isDelete?: boolean;
  onClick: () => void;
}

export interface GetActionMenuItemsParams {
  handleDelete: (id: string | number) => void;
  goalId: string | number | undefined;
}

export const getActionMenuItems = ({
  handleDelete,
  goalId,
}: GetActionMenuItemsParams): ActionMenuItem[] => [
  {
    label: 'Delete goal',
    icon: <Icons.Delete customClass="text-critical-500 mr-2" />,
    isDelete: true,
    onClick: () =>
      renderModal({
        headerText: `Are you sure you want to delete this goal?`,
        onConfirmCallback: () => {
          if (goalId !== undefined) handleDelete(goalId);
        },
        onConfirmButtonLabel: 'Delete the goal',
      }),
  },
];
